<template>
  <svg class="qr" :viewBox="`0 0 ${matrix.size} ${matrix.size}`" role="img" :aria-label="label"
       shape-rendering="crispEdges" xmlns="http://www.w3.org/2000/svg">
    <rect class="qr__bg" :width="matrix.size" :height="matrix.size" />
    <path class="qr__fg" :d="matrix.path" />
  </svg>
</template>

<script setup>
import { computed } from "vue";
import { encode } from "uqr";

const props = defineProps({
  value: { type: String, required: true },
  label: { type: String, default: "" }
});

// Rendered locally from the otpauth URI: the TOTP secret never leaves the browser for a QR service.
const matrix = computed(() => {
  const { data, size } = encode(props.value, { ecc: "M", border: 2 });
  let path = "";
  for (let y = 0; y < size; y++) {
    for (let x = 0; x < size; x++) if (data[y][x]) path += `M${x} ${y}h1v1h-1z`;
  }
  return { size, path };
});
</script>

<style scoped>
.qr { display: block; width: 100%; max-width: 220px; height: auto; }
.qr__bg { fill: var(--grey-0); }
.qr__fg { fill: var(--grey-900); }
</style>
